import React, { useState } from "react";
import { toast } from "react-toastify";
import { PropagateLoader } from "react-spinners";
import { MdDelete, MdEdit } from "react-icons/md";
import DataTable from "react-data-table-component";
import NoData from "../../atoms/NoData";
import Button from "../../atoms/Button";
import CardTables from "../../atoms/CardTables";
import Modal from "../../molecules/Modal";
import ModalConfirm from "../../molecules/ModalConfirm";
import EditAbogado from "./EditAbogado";
import { DELETE_LAWYER, DELETE_USER } from "../../../api/apiAdmin";
import useModal from "../../../hooks/useModal";

const LawyersTable = ({ data, loading, refetch }) => {
    const [lawyer, setLawyer] = useState();
    const { open:open2, close:close2, isOpen:isOpen2 } = useModal();
    const { open:open3, close:close3, isOpen:isOpen3 } = useModal();

    const handleOpenEdit = (lawyer) =>{
        setLawyer(lawyer);
        open2();
    };

    const handleOpenDelete = (lawyer) => {
        setLawyer(lawyer);
        open3();
    };

    const columns = [
        {name: "Nombre", selector: row => row.name},
        {name: "Correo electronico", selector: row => row?.user?.email},
        {name: "Acciones", cell: row => (
            <div className="flex flex-row space-x-2">
                <Button text={<MdEdit size={22}/>} bgColor="blue" width="w-10" onClick={()=> handleOpenEdit(row)}/>
                <Button text={<MdDelete size={22}/>} bgColor="red" width="w-10" onClick={()=> handleOpenDelete(row)}/>
            </div>
        )},
    ];

    const handleDelete = async () => {
        try {
            await DELETE_LAWYER?.(lawyer?.id);
            await DELETE_USER?.(lawyer?.userId);
            refetch();
            close3();
            toast.success("Eliminado correctamente");
        } catch (error) {
            toast.error("Error al eliminar");
            console.error(error);
        }
    };

    return(
        <CardTables>
            <DataTable
                data={data}
                progressPending={loading}
                columns={columns}
                progressComponent={ <div className="w-full h-20 flex justify-center items-center"> <PropagateLoader color="red" /> </div> }
                noDataComponent={<NoData/>}
            />
            {isOpen2 && lawyer &&
                <Modal title="Editar usuario defensa fiscal" onClose={close2}>
                    <EditAbogado abogado={lawyer} refetch={refetch} onClose={close2} />
                </Modal>
            }
            {isOpen3 && <ModalConfirm onClose={close3} onConfirm={handleDelete} eliminacion /> }
        </CardTables>
    );
};

export default LawyersTable;